import { Listbox } from '@headlessui/react';
import Check from '../../icons/Check';
import Times from '../../icons/Times';

interface RequirementsFilterOptionsProps {
  filterOptions: any[];
  paramLabel: string;
}

const RequirementsFilterOptions: React.FC<RequirementsFilterOptionsProps> = ({
  filterOptions,
  paramLabel,
}) => {
  return (
    <>
      {filterOptions?.map((filter, index) => {
        return (
          <Listbox.Option key={filter} value={filter}>
            {({ selected }) => (
              <div className={`py-1 relative flex items-center`}>
                <div className="w-10 h-8">
                  <input
                    type="checkbox"
                    className="w-10 h-10 opacity-0"
                    name={`${paramLabel}${index}`}
                  />
                  <div className="absolute top-2.5 left-3">
                    {selected ? (
                      <Times className="w-5 h-5 stroke-checkbox" />
                    ) : (
                      <Check className="w-5 h-5 text-gray7" />
                    )}
                  </div>
                </div>
                <label
                  className={`${
                    selected ? 'font-bold text-checkbox' : 'text-gray1'
                  } text-base  cursor-pointer`}
                >
                  {filter}
                </label>
              </div>
            )}
          </Listbox.Option>
        );
      })}
    </>
  );
};

export default RequirementsFilterOptions;
